import type { PrivateContent } from '../services/api';

/** Align with pipelines `YOUTUBE_SHORT_FORM_MAX_DURATION_SECONDS` (short-form YouTube in Mi Contenido). */
export const YOUTUBE_SHORT_FORM_MAX_DURATION_SECONDS = 300;

export type ContentShortFormFields = Pick<
  PrivateContent,
  'source' | 'mediaType' | 'duration'
>;

/**
 * Long-form YouTube path: timeline + pipeline brand mentions. YouTube `video` with unknown duration or ≥ 5 min.
 */
export function isYouTubeLongFormMentionMode(
  c: ContentShortFormFields | null | undefined,
): boolean {
    if (!c || c.source !== 'youtube' || c.mediaType !== 'video') return false;
    return c.duration == null || c.duration >= YOUTUBE_SHORT_FORM_MAX_DURATION_SECONDS;
}

/**
 * Manual "Marcas Presentes" / add presence: Shorts, non-YouTube, or YouTube video under 5 minutes.
 */
export function showManualBrandPresenceSections(
  c: ContentShortFormFields | null | undefined,
): boolean {
    if (!c) return false;
    if (c.source !== 'youtube') return true;
    if (c.mediaType === 'short') return true;
    if (c.mediaType === 'video' && typeof c.duration === 'number' && c.duration < YOUTUBE_SHORT_FORM_MAX_DURATION_SECONDS) {
        return true;
    }
    return false;
}
